export const REQUEST_VIDEO = 'REQUEST_VIDEO';
export const FAILURE_VIDEO = 'FAILURE_VIDEO';
export const SUCCESS_VIDEO = 'SUCCESS_VIDEO';
export const LOADING_VIDEO = 'LOADING_VIDEO';
